import { takeEvery, fork } from "redux-saga/effects";
import authConstants from "./auth/CONSTANTS";

const onStopStorages = [];
export const addOnStopStorage = (stopSyncStorage) => {
  onStopStorages.push(stopSyncStorage);
};

function* storageSaga() {
  yield fork(storageSagaWatcher);
  function* storageSagaWatcher() {
    yield takeEvery(authConstants.RESET_ALL, storageSagaWorker);

    function* storageSagaWorker() {
      onStopStorages.map(f => f());
      yield;
    }
  }
}

export default storageSaga;